<template>
  <div class="ticketing-service">
    <div class="page-header-banner">
      <div class="banner-main-content">
        <h1>大会门票</h1>
        <p>Conference tickets</p>
        <p>早鸟票数量有限，先到先得！</p>
      </div>
    </div>
    <div class="ticket-part">
      <div class="ticket-list">
        <div
          class="ticket-type-info"
          v-for="(item, index) in ticketInfo"
          :key="index"
        >
          <div
            :class="
              item.ticket_type == 1
                ? 'birds-icon'
                : item.ticket_type == 2
                ? 'king-icon'
                : ''
            "
          ></div>
          <div class="ticket-price-info">
            <div
              :class="[
                'ticket-name',
                { 'only-one-price': item.ticket_type != 1 }
              ]"
            >
              {{ item.name ? item.name : "" }}
            </div>
            <div class="ticket-price-present">
              ￥{{ item.price || item.price == 0 ? item.price : ""
              }}<span style="font-size:20px;font-family: PingFangSC-Regular"
                >/张</span
              >
            </div>
            <div class="ticket-price-original" v-if="item.ticket_type == 1">
              原价￥{{ item.ori_price ? item.ori_price : "" }}/张
            </div>
            <div class="to-buy-ticket" @click="goToTicket(item)">立即抢购</div>
          </div>
          <div class="ticket-include" v-if="item.ticket_type != 2">
            <div class="include-title">门票包含以下权益：</div>
            <div class="include-content">
              <div>主论坛</div>
              <div>9大技术分论坛</div>
              <div>
                开发工作坊
              </div>
              <div>互动体验区</div>
              <div>会议伴手礼袋</div>
            </div>
          </div>
          <div class="ticket-include" v-else>
            <div class="include-title">门票包含以下权益：</div>
            <div class="include-content">
              <div>主论坛</div>
              <div>9大技术分论坛</div>
              <div>开发工作坊</div>
              <div>互动体验区</div>
              <div>会议伴手礼袋</div>
              <div>会议午餐（商务简餐）</div>
              <div>主论坛VIP席位</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { showTicket, checkLogin } from "@/api/developerConference.js";
import store from "@/store";
export default {
  data() {
    return {
      ticketInfo: {
        // name: '通票',
        // description: '恒生开发者的年度盛宴，重磅开席，等你参加！', //"恒生开发者的年度盛宴，重磅开席，等你参加！"
        // price: 388.0,
        // ori_price: 388.0,
        // tip: '',
        // ticket_id: '',
        // ticket_type: 3 //1-早鸟票 2-皇冠 3-其他
      } //通票票面信息
      // VIPInfo: {
      //   name: 'VIP票',
      //   description: '恒生开发者的年度盛宴，重磅开席，等你参加！', //"恒生开发者的年度盛宴，重磅开席，等你参加！"
      //   price: '888.0',
      //   ori_price: 888.0,
      //   tip: '',
      //   ticket_id: ''
      // } //vip票面信息
    };
  },
  inject: ["reload"],
  computed: {},

  created() {
    this.getTecktetInfo(); //获取票面信息
    // this.checkIsLogin() //验证是否登陆
  },

  mounted() {},

  methods: {
    reflesh() {
      this.reload();
    },
    //获取票面信息
    getTecktetInfo() {
      showTicket().then(res => {
        if (res) {
          this.ticketInfo = res;
          // this.VIPInfo = res[1]
        }
      });
    },
    //验证是否登陆
    checkIsLogin() {
      checkLogin().then(res => {
        // console.log('1')
      });
    },
    //跳转购票页
    goToTicket(info) {
      this.$router.push({
        path: "/developerConference/ticketing"
      });
      localStorage.setItem("ticketInfo", JSON.stringify(info));
    }
  },

  beforeDestroy() {}
};
</script>
<style lang="scss" scoped>
.ticketing-service {
  .page-header-banner {
    width: 100%;
    min-width: 1200px;
    height: 465px;
    background: url("../../../assets/developerConference/buy_ticket_banner-big.jpg")
      no-repeat center;
    background-size: cover;
    color: #ffffff;
    .banner-main-content {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      h1 {
        font-family: MicrosoftYaHei-Bold;
        font-size: 44px;
        padding-top: 159px;
        color: #333333;
        line-height: 54px;
        font-weight: 700;
      }
      p {
        font-family: MicrosoftYaHei-Bold;
        font-size: 28px;
        color: #ffffff;
        color: #000000;
        text-align: left;
        &:last-of-type {
          font-family: MicrosoftYaHei;
          font-size: 22px;
          opacity: 0.8;
          padding-top: 5px;
        }
      }
    }
  }
  @media screen and (max-width: 1366px) {
    .page-header-banner {
      height: 387px;
      background-size: cover;
    }
  }
  @media (min-width: 1366px) and (max-width: 1500px) {
    .page-header-banner {
      background-position: -300px;
    }
  }
  @media (min-width: 1500px) and (max-width: 1720px) {
    .page-header-banner {
      background-position: -200px;
    }
  }
  @media (min-width: 1720px) and (max-width: 1900px) {
    .page-header-banner {
      background-position: -100px;
    }
  }
  .ticket-part {
    margin: 0 auto;
    padding: 85px 0 120px;
    width: 1200px;
    overflow: hidden;
    .ticket-list {
      width: 1200px;
      display: flex;
      justify-content: space-between;
      > div {
        border: 1px solid #d2dbe8;
        border-radius: 3px;
        background: #fff;
        width: 585px;
        height: 258px;
      }
      .ticket-type-info {
        position: relative;
        &:before {
          display: inline-block;
          content: "";
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background-color: #f1f2f7;
          position: absolute;
          top: -10px;
          left: 329px;
        }
        &:after {
          display: inline-block;
          content: "";
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background-color: #f1f2f7;
          position: absolute;
          bottom: -10px;
          left: 329px;
        }
        .birds-icon {
          position: absolute;
          top: -46px;
          left: 6px;
          width: 52px;
          height: 54px;
          background: url("../../../assets/developerConference/birds.png")
            no-repeat center;
          background-size: 100% 100%;
        }
        .king-icon {
          position: absolute;
          top: -38px;
          left: 6px;
          width: 46px;
          height: 43px;
          background: url("../../../assets/developerConference/king.png")
            no-repeat center;
          background-size: 100% 100%;
        }
        .ticket-price-info {
          width: 339px;
          height: 100%;
          padding: 44px 0px 46px 42px;
          border-right: 1px dashed #d2dbe8;
          float: left;
          .ticket-name {
            margin-bottom: 5px;
            font-family: MicrosoftYaHei-Bold;
            font-weight: 700;
            font-size: 24px;
            color: #000000;
            letter-spacing: 1.71px;
            padding-left: 4px;
          }
          .only-one-price {
            margin-bottom: 15px;
          }
          .ticket-price-present {
            color: #ff5c5c;
            font-family: ArialMT;
            font-size: 32px;
          }
          .ticket-price-original {
            color: #888888;
            text-decoration: line-through;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            padding-left: 4px;
          }
          .to-buy-ticket {
            width: 159px;
            height: 40px;
            background: #1f70fd;
            border-radius: 4px;
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #ffffff;
            position: absolute;
            bottom: 46px;
            left: 46px;
            text-align: center;
            line-height: 40px;
            padding-left: 4px;
            cursor: pointer;
          }
        }
        .ticket-include {
          float: left;
          padding-left: 32px;
          font-size: 14px;
          color: #333333;
          padding-top: 36px;
          > div {
            line-height: 28px;
          }
          .include-content {
            margin-top: 8px;
            font-family: MicrosoftYaHei;
            > div:before {
              display: inline-block;
              content: "";
              width: 4px;
              height: 4px;
              background: #1f70fd;
              margin-right: 12px;
              vertical-align: middle;
            }
            > div:nth-child(2n):before {
              background: #16d1d0;
            }
          }
        }
        &:nth-child(2) {
          .ticket-include {
            padding-top: 13px;
            .include-content {
              > div:before {
                background: #ff5c5c;
              }
              > div:nth-child(2n):before {
                background: #e423ff;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/developerConference/ticketType.vue